// Profile.js

import React, { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged, updateProfile, updatePassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './public.css';
function Profile() {
  const [userDetails, setUserDetails] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [editedName, setEditedName] = useState('');
  const [passwordChangeMode, setPasswordChangeMode] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const navigate = useNavigate();
  const auth = getAuth()
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        // If the user is not authenticated, navigate to the login page
        navigate("/login");
      }
    });

    // Cleanup the subscription when the component unmounts
    return () => unsubscribe();
  }, [navigate]);
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // Extract and set user details
        setUserDetails({
          displayName: user.displayName || 'User',
          email: user.email || 'Not available',
          phoneNumber: user.mobile || null,
        });
        // Set edited value to the current user's name
        setEditedName(user.displayName || '');
        // Set mobile number if available
        setMobileNumber(user.phoneNumber || '');
      }
    });

    return () => {
      unsubscribe(); // Cleanup the subscription when the component unmounts
    };
  }, []);

  const handleEditToggle = () => {
    setEditMode(!editMode);
  };

  const handleUpdateProfile = async () => {
    const auth = getAuth();
    try {
      await updateProfile(auth.currentUser, {
        displayName: editedName,
      });
      console.log('Profile updated successfully');
      setEditMode(false);
    } catch (error) {
      console.error('Error updating profile:', error.message);
    }
  };

  const handlePasswordChangeToggle = () => {
    setPasswordChangeMode(!passwordChangeMode);
  };

  const handleChangePassword = async () => {
    const auth = getAuth();
    try {
      await updatePassword(auth.currentUser, newPassword);
      console.log('Password changed successfully');
      setPasswordChangeMode(false);
    } catch (error) {
      console.error('Error changing password:', error.message);
    }
  };

  return (
    <div className="profile-container">
      <h2>Your Profile</h2>
      {userDetails ? (
        <>
          <div className="user-details">
            <p><strong>Name:</strong> {userDetails.displayName}</p>
            <p><strong>Email:</strong> {userDetails.email}</p>
            {userDetails.mobile && (
              <p>
                <strong>Mobile Number:</strong> {userDetails.phoneNumber}
                {editMode && (
                  <>
                    <br />
                    <label>
                      Edit Mobile Number:
                      <input
                        type="text"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                      />
                    </label>
                  </>
                )}
              </p>
            )}
          </div>
          {editMode ? (
            <div className="edit-form">
              <label>
                New Name:
                <input
                  type="text"
                  value={editedName}
                  onChange={(e) => setEditedName(e.target.value)}
                />
              </label>
              <button onClick={handleUpdateProfile} className='probtn'>Update Profile</button>
            </div>
          ) : (
            <>
              <button onClick={handleEditToggle} className='probtn'>Edit Profile</button>
              <button onClick={handlePasswordChangeToggle} className='probtn'>Change Password</button>
            </>
          )}
          {passwordChangeMode && (
            <div className="password-change-form">
              <label>
                Old Password:
                <input
                  type="password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
              </label>
              <label>
                New Password:
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </label>
              <button onClick={handleChangePassword}>Change Password</button>
            </div>
          )}
        </>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default Profile;
